// extracted by mini-css-extract-plugin
module.exports = {"root":"chart-panel-layout-tall_root__kTIUE"};